import type {
  SummerMonthlyWeather,
  WinterMonthlyWeather,
} from '@/cms/fields/types/content-page'

export type TemperatureTier = 1 | 2 | 3
export type SnowTier = 1 | 2 | 3

const MONTHS_IN_YEAR = 12
const WINTER_SEASON_START_MONTH = 11

interface MonthlyMetric {
  month: number
  value: number
}

export function hasSnowHeight(month: WinterMonthlyWeather): boolean {
  return month.snowDepthTopCm > 0 || month.snowDepthBottomCm > 0
}

export function computeTiers(months: SummerMonthlyWeather[]): Map<number, TemperatureTier> {
  return computeMonthlyMetricTiers(months.map(month => ({
    month: month.month,
    value: month.maxTemp,
  })))
}

export function computeSnowTiers(months: WinterMonthlyWeather[]): Map<number, SnowTier> {
  return computeMonthlyMetricTiers(months.map(month => ({
    month: month.month,
    value: month.snowDepthTopCm,
  })))
}

export function orderWinterMonths(months: readonly WinterMonthlyWeather[]): WinterMonthlyWeather[] {
  return [...months].sort(byWinterSeason)
}

function byWinterSeason(firstMonth: WinterMonthlyWeather, secondMonth: WinterMonthlyWeather): number {
  return getWinterMonthOrder(firstMonth) - getWinterMonthOrder(secondMonth)
}

function getWinterMonthOrder(month: WinterMonthlyWeather): number {
  return (month.month - WINTER_SEASON_START_MONTH + MONTHS_IN_YEAR) % MONTHS_IN_YEAR
}

function computeMonthlyMetricTiers(months: MonthlyMetric[]): Map<number, TemperatureTier> {
  const sorted = [...months].sort((firstMonth, secondMonth) => secondMonth.value - firstMonth.value)
  return new Map(sorted.map((month, index) => {
    const tier: TemperatureTier = index < 4 ? 1 : index < 8 ? 2 : 3
    return [month.month, tier]
  }))
}
